import styled from 'styled-components';

export const CheckboxContainer = styled.div<{
  noMargin?: boolean;
  align?: 'left' | 'center' | 'right';
}>`
  margin-top: ${(props) => (props.noMargin ? '0px' : '30px')};
  display: flex;
  justify-content: ${(props) => props.align ?? 'center'};
`;
